import Button from "@/components/input/Button";

const HireAgainButton: React.FC = () => {
  return <Button>Hire again</Button>;
};

export default HireAgainButton;
